import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css';

// Swiper
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';

import 'swiper/swiper-bundle.css';

//Lightgallery
import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'


//Lenis
import Lenis from '@studio-freight/lenis'

const lenis = new Lenis()

lenis.on('scroll', (e) => {
  //console.log(e)
})

function raf(time) {
  lenis.raf(time)
  requestAnimationFrame(raf)
}

requestAnimationFrame(raf)


$("document").ready(function() {

  var lastScrollTop = 0;
  function setHeaderTopHeight() {
      var h = $('.headerTop').outerHeight();
      document.documentElement.style.setProperty('--header-top-height', '-' + h + 'px');
  }
  setHeaderTopHeight();
  $(window).resize(setHeaderTopHeight);

  $(window).scroll(function () {
    var st = $(window).scrollTop();
    if (st > 0) {
        $('header').addClass('scrolling');
    } else {
        $('header').removeClass('scrolling');
    }
    if ($(window).width() > 1020) {
        if (st > lastScrollTop && st > 80) {
            $('header').addClass('header-top-hidden');
        } else {
            $('header').removeClass('header-top-hidden');
        }
    } else {
        $('header').removeClass('header-top-hidden');
    }
    lastScrollTop = st <= 0 ? 0 : st;
  });

  // Search overlay
  $('.searchTrigger').click(function() {
      $('.searchOverlay').addClass('active');
      $('body').css('overflow', 'hidden');
  });
  $('.searchOverlayClose').click(function() {
      $('.searchOverlay').removeClass('active');
      $('body').css('overflow', '');
  });
  $('.searchOverlay').click(function(e) {
      if ($(e.target).is('.searchOverlay')) {
          $(this).removeClass('active');
          $('body').css('overflow', '');
      }
  });
  $(document).keydown(function(e) {
      if (e.key === 'Escape') {
          $('.searchOverlay').removeClass('active');
          $('body').css('overflow', '');
      }
  });

  $('.hamburger-lines').click(function() {
    $(this).toggleClass('active');
      $('.mobileMenu').toggleClass('active');

      return false;
  });
  if ($('.galleryItem').length > 0) {
   
    lightGallery(document.getElementById('gallery'), {
        plugins: [lgZoom, lgThumbnail],
        speed: 500,
        licenseKey: '9103CF58-FD6A-4DF5-94DF-29E779C44F84',
        selector: '.galleryItem'
    });
  }
  if (document.querySelectorAll('.scrollToTop').length > 0) {
    var scrollToTopButton = $('.scrollToTop');
      scrollToTopButton.click(function () {
        // Animate scrolling to the top
        $('html, body').animate({ scrollTop: 0 }, 500); // Adjust the duration as needed
    });
  }

if($('.mobileMenu li a').length>0) { 
  $('.mobileMenu li.menu-item-has-children > a').click(function() {
    if($(this).parent().hasClass('menu-item-has-children')) {
      $(this).toggleClass('active');
      $(this).parent().find('.sub-menu').first().slideToggle();
    } else {
 $('.hamburger-lines').toggleClass('active');
      $('.mobileMenu').toggleClass('active');
    }
    return false;
  });
  
}
if (document.querySelectorAll('.heroSwiper').length > 0) {
  new Swiper(".heroSwiper", {
    modules: [Pagination, Autoplay, EffectFade],
    effect: 'fade',
    fadeEffect: { crossFade: true },
    loop: true,
    autoplay: { delay: 5000, disableOnInteraction: false },
    pagination: {
      el: '.heroSwiper-pagination',
      clickable: true,
    },
  });
}

if (document.querySelectorAll('.eventsSwiper').length > 0) {
  let eventsSwiper = new Swiper(".eventsSwiper", {
    slidesPerView: 1,
    spaceBetween: 24,
    navigation: {
      nextEl: ".eventsSwiper-next",
      prevEl: ".eventsSwiper-prev",
    },
    pagination: {
      el: '.eventsSwiper .swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      768: { slidesPerView: 2 },
      1024: { slidesPerView: 3 },
    }
  });

  $('.eventsFilter .filterBtn').click(function() {
    $('.eventsFilter .filterBtn').removeClass('active');
    $(this).addClass('active');
    var filter = $(this).data('filter');
    $('.eventsSwiper .swiper-slide').each(function() {
      if (filter === 'all' || $(this).data('terms').split(' ').indexOf(filter) > -1) {
        $(this).removeClass('hidden');
      } else {
        $(this).addClass('hidden');
      }
    });
    eventsSwiper.update();
  });
}

if (document.querySelectorAll('.swiper').length > 0) {
  let swiperCarousel = new Swiper(".tudtaSlider", {
    loop: true,
    autoplay: {
      delay: 3000, 
      disableOnInteraction: false, 
    },
    navigation: {
      nextEl: ".swiper-progs-button-next",
      prevEl: ".swiper-progs-button-prev",
    }, 
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    spaceBetween: 0,
    breakpoints: {
      501: {
        slidesPerView: 1,
        spaceBetween: 20
      }   
    }
  });
}  
  // Count-up animation on scroll into view
  if (document.querySelectorAll('.numbersStats__number').length > 0) {
    var countUpDone = false;
    function runCountUp() {
      if (countUpDone) return;
      countUpDone = true;
      document.querySelectorAll('.numbersStats__number').forEach(function(el) {
        var target = parseInt(el.getAttribute('data-target'), 10) || 0;
        var duration = 1800;
        var start = null;
        function step(timestamp) {
          if (!start) start = timestamp;
          var progress = Math.min((timestamp - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = Math.floor(eased * target);
          if (progress < 1) requestAnimationFrame(step);
          else el.textContent = target;
        }
        requestAnimationFrame(step);
      });
    }
    var statsSection = document.querySelector('.numbersStats');
    if (statsSection && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        if (entries[0].isIntersecting) {
          runCountUp();
          observer.disconnect();
        }
      }, { threshold: 0.3 });
      observer.observe(statsSection);
    } else {
      runCountUp();
    }
  }

  if ($('.accordion').length > 0) {
      $('.accordionHeader').click(function() { 
          $(this).parent().toggleClass('active');
          $(this).parent().find('.accordionContent').slideToggle();

          
          return false;
      });                
  }

  
    $('a[href*="#"]:not([href="#"])').click(function() {
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
            var targetHash = this.hash;
            var decodedHash = decodeURIComponent(targetHash);
            var target = $(decodedHash);
            
            target = target.length ? target : $('[name=' + decodedHash.slice(1) +']');
            
            if (target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top - 200
                }, 1000);
                return false;
            }
        }
    });

});